<template>
  <a-modal
    :title="title"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <!-- 结清状态 - 新增@change事件 -->
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="结清状态">
          <dict-select
            v-decorator="['settleStatus']"
            :dict-code="DICT_CODE.SETTLE_STATUS"
            :begin="[{ value: '', label: '全部', labelEn: 'All' }]"
            :placeholder="$t('select')"
            @change="handleSettleStatusChange"
          />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { modifyNewOrderStatus } from '@/webpublicapi/order'
import DictSelect from '../../modules/DictSelect'
import moment from 'moment'

// duplicateCheck
export default {
  name: 'TestOrderModal',
  components: {
    DictSelect,
  },
  data() {
    return {
      value: 1,
      title: '操作',
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
    }
  },
  created() {},
  methods: {
    add() {
      this.edit({})
    },
    getInitTime(timeStr) {
      if (moment.isMoment(timeStr)) {
        return timeStr
      }
      // 其他情况转字符串处理
      const str = typeof timeStr === 'string' ? timeStr : String(timeStr || '')
      if (str.trim() !== '') {
        return moment(str, 'YYYY-MM-DD HH:mm:ss')
      } else {
        return moment()
      }
    },
    getInitTimeAgo(timeStr) {
      if (moment.isMoment(timeStr)) {
        return timeStr
      }
      // 其他情况转字符串处理
      const str = typeof timeStr === 'string' ? timeStr : String(timeStr || '')
      if (str.trim() !== '') {
        return moment(str, 'YYYY-MM-DD HH:mm:ss')
      } else {
        return moment().subtract(4, 'days')
      }
    },
    handleLoanStatusChange(newVal) {
      console.log('放款状态变更为：', newVal)
      this.model.loanStatus = newVal
      console.log('放款事件为：', this.model.paymentTime)
      // 第一次nextTick：等待v-if根据model.loanStatus更新DOM（渲染/销毁paymentTime字段）
      this.$nextTick(() => {
        // 第二次nextTick：等待v-decorator完成字段注册
        this.$nextTick(() => {
          if (newVal === '1') {
            const initTime = this.getInitTimeAgo(this.model.paymentTime)
            // 此时paymentTime已渲染并注册，可安全设置
            this.form.setFieldsValue({ paymentTime: initTime })
          } else {
            this.model.paymentTime = null
            // 若字段已存在则清空，不存在则忽略
            if (this.form.getFieldValue('paymentTime') !== undefined) {
              this.form.setFieldsValue({ paymentTime: null })
            }
          }
        })
      })
    },

    handleSettleStatusChange(newVal) {
      console.log('结清状态变更为：', newVal)
      this.model.settleStatus = newVal

      this.$nextTick(() => {
        this.$nextTick(() => {
          if (newVal !== null && newVal !== '' && newVal !== '0') {
            const initTime = this.getInitTime(this.model.settleTime)
            this.form.setFieldsValue({ settleTime: initTime })
          } else {
            this.model.settleTime = null
            if (this.form.getFieldValue('settleTime') !== undefined) {
              this.form.setFieldsValue({ settleTime: null })
            }
          }
        })
      })
    },
    edit(record) {
      if (record.id) {
        this.visiblekey = true
      } else {
        this.visiblekey = false
      }
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      this.$nextTick(() => {
        this.model.approvalStatus = String(this.model.approvalStatus)
        this.model.loanStatus = String(this.model.loanStatus)
        this.model.overdueStatus = String(this.model.overdueStatus)
        this.model.settleStatus = String(this.model.settleStatus)

        this.form.setFieldsValue(
          pick(
            this.model,
            'approvalStatus',
            'loanStatus',
            'overdueStatus',
            'settleStatus',
            'applyAmt',
            'interest',
            'deductionFee',
            'paymentTime',
            'settleTime'
          )
        )
      })
    },
    // 确定
    handleOk() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          const formData = Object.assign(this.model, values)
          let obj
          console.log(formData, '保存的结果是？')
          obj = modifyNewOrderStatus(formData)
          obj
            .then((res) => {
              if (res.code === 1000) {
                this.$message.success(res.msg)
                this.$emit('ok')
              } else {
                this.$message.warning(res.msg)
              }
            })
            .finally(() => {
              this.confirmLoading = false
              this.close()
            })
        }
      })
    },
    // 关闭
    handleCancel() {
      this.close()
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
  },
}
</script>